import $ from 'jquery';

export default function () {
  const $lis = $('.default > .navigation__list > li');


  $(".navigation__level:not(.default)").each(function(){
    var ref = $(this);    
    var title = ref.parent().find("a").html();    
    ref.attr("data-title",title);
  });

  const open = function open(event) {
    const $target = $(event.currentTarget);
    $target.siblings().removeClass('hover');
    $target.addClass('hover');
  };

  const close = function close(event) {
    const $target = $(event.currentTarget);
    $target.removeClass('hover');
  };

  const closeAll = function closeAll() {
    $lis.removeClass('hover');
  };

  const handleTouch = function handleTouch(event) {
    // Prevent artificial click events
    const $target = $(event.currentTarget);
    event.stopPropagation();
    if (!$target.hasClass('hover')) {
      event.preventDefault();
      $target.mouseenter();
    }
  };

  const hasTouchend = 'ontouchend' in window;
  if (hasTouchend) {
    $('body').on('touchend', closeAll);
    $lis.on('touchend', handleTouch);
  }

  $lis.on('mouseenter', open);
  $lis.on('mouseleave', close);
}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/navigation.js